import { message } from "antd";
import { useEffect, useState } from "react";
import Progress from "react-progress-2";
import { PostDataAuth } from "../apiService/PostData";
import { apis } from "../properties";

function useFundDownloadDetails({filterData}) {
  const [state, setState] = useState([]);

  useEffect(() => {
    const getData = () => {
      Progress.show();
      PostDataAuth(apis.DOWNLOAD_DETAILS, filterData).then((result) => {
        let responseJson = result;
        if (responseJson.status === "success") {
          setState(responseJson.data);
          Progress.hide();
        } else if (responseJson.status === "error") {
          message.error(responseJson.message);
          Progress.hide();
        }
      });
    };
    getData();
  }, [filterData]);
  return state;
}

export default useFundDownloadDetails;
